import Vue from 'vue'
import VeeValidate from 'vee-validate';
import App from './App.vue'
import router from './router'
import axios from './plugins/axios.js';
import store from './store';
import api from './services/api.js';
import Buefy from 'buefy';
import './filters';
import moment from 'moment';
import VueMoment from 'vue-moment';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
    dsn: 'https://405fd7d35de44988a3376635072d694d@o339827.ingest.sentry.io/1878972',
    environment: process.env.VUE_APP_ENVIRONMENT,
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
});

Vue.config.productionTip = false

require('moment/locale/es');
moment.locale('es');
Vue.use(VueMoment, {
    moment
});

// Include our plugins
Vue.use(api);
Vue.use(axios);

new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')

// Load Vee Validate and the translation files
import veeES from 'vee-validate/dist/locale/es';
import messagesES from './translation/messages.es.js';
import attributesES from './translation/attributes.es.js';
import i18n from './i18n'

Vue.use(VeeValidate, {
    events: '',
    locale: 'es',
    dictionary: {
        es: {
            messages: messagesES,
            attributes: attributesES
        },
    }
});
VeeValidate.Validator.localize('es', veeES);
VeeValidate.Validator.localize('es');

Vue.use(Buefy, {
    defaultIconPack: 'fa'
});
